


















































import { ProfileModule } from '@app/componentlib/src/store/modules/profile'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Section } from '../CvView.vue'
import { ProfileData } from '@app/componentlib/src/common/types/profileTypes'
import CvAdjustCompetences from '@app/componentlib/src/views/cvtool-pages/cv-sections/CvAdjustCompetences.vue'
import CvAdjustExperiences from '@app/componentlib/src/views/cvtool-pages/cv-sections/CvAdjustExperiences.vue'
import { CvModule } from '@app/componentlib/src/store/modules/cvdata'
import { HelpTextProfile } from '@app/componentlib/common/types/CVTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import ArrowNavigation from '@app/componentlib/src/views/components/ArrowNavigation.vue'
import { ga } from '@app/componentlib/src/application/analytics'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

@Component<CvAdjust>({
  props: {
    section: Object,
    competencesLink: String,
    startFromLast: Boolean
  },
  components: {
    CvAdjustCompetences,
    CvAdjustExperiences,
    ArrowNavigation,
    VPopover
  },
  directives: {
    VTooltip,
    VClosePopover
  }
})

export default class CvAdjust extends Vue {
  /**
   * Props variables
   */
  section: Section | undefined
  competencesLink: string | undefined
  startFromLast: boolean | undefined
  /**
   * Component state variables
   */
  activeStep = 1
  lastStep = 2
  firstStep = 1
  validSections: string[] | undefined = undefined
  missingSections: string[] | undefined = undefined
  addHelpTexts: boolean = false

  /**
   * Lifecycle
   */
  async mounted () {
    const selectedProfileId = CvModule.selectedProfileId
    if(selectedProfileId !== null) {
      console.warn('You cannot adjust your CV, as you have chosen a pre selected CV type')
      this.$emit('changeSection', {path:'2', back:false})
    }

    this.missingSections = await CvModule.GetMissingProfileSections()
    this.validSections = await CvModule.GetCVSections()
    if (this.missingSections !== undefined && this.missingSections.length > 0) {
      this.lastStep = 3
    }
    if (this.startFromLast === true) {
      this.activeStep = this.lastStep
    }
  }

  /**
   * Getters
   */
  get helpTextProfile (): HelpTextProfile | undefined {
    return CvModule.helpTextProfile
  }
  get t (): any {
    return AppModule.translations
  }
  get profileData (): ProfileData | undefined {
    return ProfileModule.profileData
  }

  get competences () {
    let competenceData = undefined
    if(this.profileData !== undefined){
      competenceData = this.profileData.competences
    }
    return competenceData
  }
  get experiences () {
    if(this.profileData) return this.profileData.experiences
    return undefined
  }

    get profileLink (): string | undefined {
    return AppModule.portalSettings.profileLink
  }

  /**
   * Methods
   */
  async changeSection (back?:boolean) {
    if(this.section !== undefined) {
      window.scrollTo(0,0)
      //Change section when first and laststep else we just add or substract a step when going back and forward in the cvadjust wizard
      if(this.activeStep === 2 && back !== true) {
        console.log('this.missingSections', this.missingSections, this.missingSections?.length)
        if(this.missingSections !== undefined && this.missingSections.length > 0) {
          this.lastStep = 3
          ga.event({
            action: 'Change Section',
            category: 'CV Tool',
            label: 'Arrows - adjust - missing sections'
          })
        }
      }
      if(this.activeStep === this.firstStep && back === true) {
        this.$emit('changeSection', {path:'2', back:true})
      } else if(this.activeStep === this.lastStep && back !== true) {
        this.$emit('changeSection', {path:'4', back:false})
      } else if(back !== true) {
        if(this.activeStep !== 2) {
          ga.event({
            action: 'Change Section',
            category: 'CV Tool',
            label: 'Arrows - adjust'
          })
        }
        this.activeStep += 1
      } else if (back === true) {
        this.activeStep -= 1
        ga.event({
          action: 'Change Section',
          category: 'CV Tool',
          label: 'Arrows - adjust'
        })
      }
    }
  }

  clearSelection() {
    ga.event({
      action: 'Clear selection',
      category: 'CV Tool',
      label: 'Bottom Adjust'
    })
    this.$emit('clearSelect')
  }

  toggleHelpTexts () {
    if(this.addHelpTexts === true && this.helpTextProfile !== undefined) {
      //Update CV Preview?
      //Add help texts to current CV
      CvModule.setHelpTexts(this.helpTextProfile.profileId)
      ga.event({
        action: 'Missing information - help texts',
        category: 'CV Tool',
        label: 'Added'
      })
    } else {
      CvModule.setHelpTexts()
      ga.event({
        action:'Missing information - help texts',
        category: 'CV Tool',
        label: 'Removed'
      })
    }
  }

  goToProfile () {
    ga.event({
      action: 'Go to profile - header',
      category: 'CV Tool',
      label: 'Your information - header'
    })
  }
}
